import React from "react";

const ModalBodyComponent = ({
  customClass = '',
  customStyle = {},
  hasHeader = true,
  hasFooter = true,
  onScroll = () => {},
  ...props
}) => {
  let style = {};

  if (!hasHeader) style.top = 0;
  if (!hasFooter) style.bottom = 0;

  return (
    <div
      className={`modal-body modal__content ${customClass}`}
      style={{ ...style, ...customStyle }}
      onScroll={onScroll}
    >
      {props.children}
    </div>
  )
}

export default ModalBodyComponent;